import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Dashboard from './components/Dashboard/Dashboard';
import AddClub from './components/AddClub/AddClub';
import AddChk from './components/AddChk/AddChk';
import AddCert from './components/AddCert/AddCert';
import AddMm from './components/AddMm/AddMm';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/addclub" element={<AddClub />} />
        <Route path="/addchk" element={<AddChk />} />
        <Route path="/addcert" element={<AddCert />} />
        <Route path="/addmm" element={<AddMm />} />
      </Routes>
    </div>
  );
}

export default App;
  